import { Button, DatePicker, Empty, Input, Table, Select } from "antd"
// import * as React from "react";
import React from 'react';
import moment from "moment";
import 'moment-timezone';
import { Loader } from "rsuite";
import { SearchOutlined, ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { AppContext } from '../context/AppContext';
import { Download } from 'react-feather';
import dayjs from "dayjs";
import { useCallback } from "react";
import { TransactionHistory } from "./modals/TransactionsHistoryModal";
import { getPayType, propertyNameList } from "../utils/utils";

const datePickerIcon = require("../assets/icons/datepicker-Icon.png")
const downIconBlur = require("../assets/icons/chevron-down.png")
const downIconFocused = require("../assets/icons/chevron-down-focused.png")

export const Transactions = () => {
    const context = React.useContext(AppContext);
    const { onGetTransactions, onFilteredTransactions, onFilteredReports, onGetReceipt } = context;
    const [loading, setLoading] = React.useState(false)
    const [transactions, setTransactions] = React.useState([])
    const [searchText, setSearchText] = React.useState("")
    const [payType, setPayType] = React.useState("")
    const [properties, setProperties] = React.useState("")
    const lastRecentDate = new Date()
    lastRecentDate.setDate(lastRecentDate.getDate() - 14)
    const [fromDate, setFromDate] = React.useState<any>(dayjs(moment(lastRecentDate).format("MM/DD/YYYY HH:mm")))
    const [toDate, setToDate] = React.useState<any>(dayjs(moment(new Date()).format("MM/DD/YYYY HH:mm")))
    const [transModalVisible, setTransModalVisible] = React.useState(false);
    const [trnsctnReceipt, setTrnsctnReceipt] = React.useState([])
    const [focusFilterPayType, setFocusFilterPayType] = React.useState(false)
    const [focusFilterProperty, setFocusFilterProperty] = React.useState(false)
    const emptyTransaction = require("../assets/icons/empty-icon.png");

    const [propertyNames, setPropertyNames] = React.useState([]);

    const columns = [
        {
            title: () => {
                return (<h4>Date & Time</h4>)
            },
            dataIndex: 'dateTime',
            key: 'dateTime',
            width: '9%',
            render: (date: any) => {
                return (
                    <div>
                        <span style={{ fontSize: '14px', color: "#27272A", fontWeight: 400 }}>
                            {moment(date).format('YYYY-MM-DD')}
                        </span>
                        <br />
                        <span style={{ fontSize: '12px', fontWeight: 300, color: "#71717A" }}>
                            {moment(date).tz("Asia/Taipei").format("HH:mm:ss")}
                        </span>
                    </div>
                )
            },
        },
        {
            title: () => {
                return (<h4>Transaction ID</h4>)
            },
            width: '11%',
            dataIndex: 'transactionID',
            key: 'transactionID',
        },
        {
            title: () => {
                return (<h4>Maya Number</h4>)
            },
            width: '8%',
            dataIndex: 'mayaNum',
            key: 'mayaNum',
        },
        {
            title: () => {
                return (<h4>Scheduled Payment</h4>)
            },
            width: '9%',
            dataIndex: 'schedPayment',
            key: 'schedPayment',
        },
        {
            title: () => {
                return (<h4>CIN/HN</h4>)
            },
            width: '6%',
            dataIndex: 'cinHN',
            key: 'cinHN',
        },
        {
            title: () => {
                return (<h4>Entity</h4>)
            },
            width: '6%',
            dataIndex: 'tenant',
            key: 'tenant',
        },
        {
            title: () => {
                return (<h4>Property Name</h4>)
            },
            width: '6%',
            dataIndex: 'propertyName',
            key: 'propertyName',
        },
        {
            title: () => {
                return (<h4>Unit Number</h4>)
            },
            width: '6%',
            dataIndex: 'unit',
            key: 'unit',
        },
        {
            title: () => {
                return (<h4>Buyer's Name</h4>)
            },
            width: '5%',
            dataIndex: 'buyerName',
            key: 'buyerName',
        },
        {
            title: () => {
                return (<h4>Payment Type</h4>)
            },
            width: '5%',
            dataIndex: 'payType',
            key: 'payType',
        },
        {
            title: () => {
                return (<h4>Payment Method</h4>)
            },
            width: '6%',
            dataIndex: 'payMethod',
            key: 'payMethod',
        },
        {
            title: () => {
                return (<h4>Start Date</h4>)
            },
            width: '8%',
            dataIndex: 'startDate',
            key: 'startDate',
        },
        {
            title: () => {
                return (<h4>Duration</h4>)
            },
            width: '6%',
            dataIndex: 'duration',
            key: 'duration',
        },
        {
            title: () => {
                return (<h4>Amount</h4>)
            },
            width: '6%',
            dataIndex: 'amnt',
            key: 'amnt',
        },
        {
            title: () => {
                return (<h4>Transaction Fee</h4>)
            },
            width: '10%',
            render: (text: any, record: any) => {
                return (
                    <div>
                        <span style={{ fontSize: '14px', color: "#27272A" }}>
                            MDR: {parseFloat(record.mdr).toFixed(2)}
                        </span>
                        <br />
                        <span style={{ fontSize: '14px', color: "#27272A" }}>
                            Platform Fee: {parseFloat(record.platformFee).toFixed(2)}
                        </span>
                        <br />
                        <span style={{ fontSize: '14px', color: "#27272A" }}>
                            Total: {parseFloat(record.transFee).toFixed(2)}
                        </span>
                    </div>
                )
            },
        },
        {
            title: () => {
                return (<h4>Total Amount</h4>)
            },
            dataIndex: 'totalAmnt',
            key: 'totalAmnt',
            align: 'right' as const,
            fixed: 'right' as const,
            width: "12%",
            headerStyle: { textAlign: 'right' },
        },
    ]

    const getTransactions = useCallback(async () => {
        try {
            setLoading(true);
            let response = []
            if (searchText !== "" || payType !== "" || properties !== "") {
                response = await onFilteredTransactions(payType, fromDate, toDate, searchText, properties);
            } else {
                response = await onGetTransactions(fromDate, toDate);
            }

            if (!response) return setTransactions([]);

            const Transactions = getTransactionsInfo(response)

            setTransactions(Transactions);
        } catch (e) {
            setTransactions([]);
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [searchText, fromDate, toDate, payType, properties, onFilteredTransactions, onGetTransactions, setTransactions, setLoading]);

    const getTransactionsInfo = (data: string[]) => {
        return data.map((item: any, index: any) => {
            // const isReservation = item.type === "Reservation"
            const scheduledPayment = item?.recurring_payment_id ? "Yes" : "No"
            const propertyName = !item.name ? "N/A" : item.name
            const unit = !item.unit ? "N/A" : item.unit
            const buyerName = !item.buyers_name ? "N/A" : item.buyers_name
            const startDate = !item.start_date ? "N/A" : moment(item.start_date).format('YYYY-MM-DD')
            const duration = !item.duration ? "N/A" : item.duration
            const mdrFee = !item.mdr ? 0 : parseFloat(item.mdr) / 100
            const platformFee = !item.platform_fee ? 0 : parseFloat(item.platform_fee) / 100
            const transFee = !item.fees_amount ? 0 : parseFloat(item.fees_amount) / 100
            const totalAmount = !item.total_amount ? 0 : parseFloat(item.total_amount) / 100
            const bforAmnt = totalAmount - transFee
            const payType = getPayType().filter((type: any) => {
                return type.label === item.type
            }) as any;
            const payTypeLabel = payType.length > 0 ? payType[0].label : 'N/A'

            const mayaNumber = item.channel === 'BayaniPay' ? "N/A" : item.payment_id

            return {
                key: item.payment_id,
                dateTime: item.paid_on,
                transactionID: item.reference_id,
                mayaNum: mayaNumber,
                schedPayment: scheduledPayment,
                cinHN: item.cin,
                propertyName: propertyName,
                unit: unit,
                buyerName: buyerName,
                payType: payTypeLabel,
                payMethod: item.channel.replace("_", " "),
                startDate: startDate,
                duration: duration,
                amnt: new Intl.NumberFormat('en-PH', {
                    style: 'currency',
                    currency: 'PHP',
                }).format(bforAmnt),
                mdr: mdrFee,
                platformFee: platformFee,
                transFee: transFee,
                totalAmnt: new Intl.NumberFormat('en-PH', {
                    style: 'currency',
                    currency: 'PHP',
                }).format(totalAmount),
                tenant: item.tenant
            }
        });
    }

    const locale = {
        emptyText: (
            <div style={{ padding: "30px 20px" }}>
                <Empty
                    image={emptyTransaction}
                    imageStyle={{
                        display: "flex",
                        justifyContent: "center",
                        height: 180
                    }}
                    description={
                        <span>
                            No transactions to show
                        </span>
                    }
                />
            </div>

        ),
    };

    const getCalc = (height: number) => {
        let calc = 1
        switch (true) {
            case height >= 500 && height < 600:
                calc = 1.3
                break
            case height >= 600 && height < 700:
                calc = 1.5
                break
            case height >= 700 && height < 750:
                calc = 1.8
                break
            case height >= 750 && height < 800:
                calc = 1.9
                break
            case height >= 800 && height < 850:
                calc = 2.1
                break
            case height >= 850 && height < 900:
                calc = 2.2
                break
            case height >= 900 && height < 950:
                calc = 2.4
                break
            case height >= 950 && height < 1050:
                calc = 2.4
                break
            case height >= 1050 && height < 1280:
                calc = 3
                break
            case height >= 1280 && height < 1440:
                calc = 3.3
                break
            case height >= 1440 && height < 1680:
                calc = 4
                break
            case height >= 1680:
                calc = 4.5
                break
        }
        return calc
    }
    const calcHeight = (val: any) => (val - (Math.round(val / getCalc(window.innerHeight))))
    const [height, setHeight] = React.useState(calcHeight(window.innerHeight))

    React.useEffect(() => {
        const detectWindowHeight = (h: any) => setHeight(calcHeight(h))
        window.addEventListener("resize", (e: any) => detectWindowHeight(e.target.innerHeight))
        return () => window.removeEventListener("resize", (e: any) => detectWindowHeight(e.target.innerHeight))
    })

    React.useEffect(() => {
        getTransactions()
    }, [getTransactions]);

    React.useEffect(() => {
        const fetchProperties = async () => {
          try {
            const fetchedProperties = await propertyNameList();
            setPropertyNames(fetchedProperties);
          } catch (error) {
            console.error("Error fetching properties:", error);
            setPropertyNames([{ name: "All Properties" }]);
          }
        };
      
        fetchProperties();
      }, []);

    const handleTrnscnModalCancel = () => {
        setTransModalVisible(false);
    };

    const handleOpenTransactionModal = () => {
        setTransModalVisible(true);
    };

    const handleDownloadCSV = async () => {
        const filename = `smdc-expresspay-${moment(new Date()).format("MMDDYYYY-hh-mm")}`;

        try {
            const reports = await onFilteredReports(payType, fromDate, toDate, searchText)
            const blob = new Blob([reports], { type: 'text/csv' });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;


            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (e) {
            console.error(e);
        } finally {
            return;
        }
    }

    const handleScrollSize = () => {
        if (!transactions) return
        return { x: 'max-content', y: height }
    }

    const range = (start: number, end: number) => {
        var ans = [];
        for (let i = start; i <= end; i++) {
            ans.push(i);
        }
        return ans;
    }

    return (
        <div style={{ padding: '32px, 24px, 32px, 24px' }}>
            <TransactionHistory
                open={transModalVisible}
                onClose={handleTrnscnModalCancel}
                receipt={trnsctnReceipt}
            />
            {loading && <Loader size="lg" backdrop />}
            <div className="flex flex-row justify-between items-center">
                <div className="text-header1 font-interBold text-neutralBlack" style={{ fontSize: 32, fontWeight: 700 }}>Transactions</div>
                <div className="flex items-center">
                    <DatePicker
                        suffixIcon={<img src={datePickerIcon} width={21} height={21} alt="SMDC Date Picker Logo" />}
                        style={{ width: 190, height: 40 }}
                        className="mx-3 font-interRegular"
                        onChange={(date) => setFromDate(date)}
                        value={fromDate}
                        format="MM/DD/YYYY HH:mm"
                        showTime={{ format: "HH:mm" }}
                    />
                    <span className="font-interRegular mx-3">to</span>
                    <DatePicker
                        suffixIcon={<img src={datePickerIcon} width={21} height={21} alt="SMDC Date Picker Logo" />}
                        style={{ width: 190, height: 40 }}
                        className="mx-3 font-interRegular"
                        onChange={(date) => setToDate(date)}
                        disabledDate={(date: any) => {
                            return date < fromDate
                        }}
                        disabledTime={(date: any) => {
                            const datePicker = Math.floor(Date.parse(date) / 1000)
                            const startDate = Math.floor(Date.parse(fromDate) / 1000)
                            if (datePicker <= startDate) {
                                const hoursDisable = moment(fromDate.toLocaleString()).hour()
                                const minutesDisable = moment(fromDate.toLocaleString()).minutes()
                                return {
                                    disabledHours: () => range(0, 24).splice(0, +hoursDisable),
                                    disabledMinutes: () => range(0, +minutesDisable)
                                }
                            }
                        }}
                        value={toDate}
                        format="MM/DD/YYYY HH:mm"
                        showTime={{ format: "HH:mm" }}
                    />
                </div>
            </div>
            <div className="mt-4" style={{ boxShadow: "0px -1px 3px 0px #00000014" }}>
                <div className="py-6 px-4 bg-neutralWhite-pure flex items-center">
                    <Input
                        placeholder="Search"
                        allowClear
                        onChange={(e) => setSearchText(e.target.value)}
                        className="search-filter"
                        style={{ width: 250, height: 40, marginRight: 16, backgroundColor: '#FDFDFD' }}
                        suffix={<SearchOutlined style={{ color: '#A1A1AA', width: '12.97px', height: '12.97px' }} />}
                    />
                    <Select
                        placeholder="Filter by Payment Type"
                        className={focusFilterPayType ? 'payment-type-filter-focused' : 'payment-type-filter'}
                        size="large"
                        options={getPayType()}
                        style={{ width: 260, backgroundColor: '#FDFDFD', marginRight: 16 }}
                        onChange={(e) => setPayType(e)}
                        onDropdownVisibleChange={(open) => setFocusFilterPayType(open)}
                        suffixIcon={<img src={focusFilterPayType ? downIconFocused : downIconBlur} width={16} height={16} alt="" />}
                    />
                    <Select
                        placeholder="Filter by Property"
                        size="large"
                        className={focusFilterProperty ? 'payment-type-filter-focused' : 'payment-type-filter'}
                        options={propertyNames.map((_prop) => ({
                            value: _prop.name === "All Properties" ? "" : _prop.name,
                            label: _prop.name
                          }))}
                        style={{ width: 260, backgroundColor: '#FDFDFD' }}
                        onChange={(e) => setProperties(e)}
                        onDropdownVisibleChange={(open) => setFocusFilterProperty(open)}
                        suffixIcon={<img src={focusFilterProperty ? downIconFocused : downIconBlur} width={16} height={16} alt="" />}
                    />
                    <div className="flex ml-auto">
                        <Button className="bg-primary font-interBold text-xs leading-6 border-primary hover:bg-primary-hovered hover:text-neutral-50 active:border-primary-border active:bg-primary-clicked"
                            style={{ alignItems: 'center', display: 'flex', height: 40, color: '#FCFDFD', fontWeight: 700, fontSize: 12, borderRadius: 5, padding: '8px, 14px, 8px, 10px' }}
                            onClick={handleDownloadCSV}
                        >
                            <Download style={{ width: 20, height: 20, color: "#FCFDFD", border: '1.5px' }} className="mr-2" />
                            Download CSV
                        </Button>
                    </div>
                </div>
                <Table
                    tableLayout="auto"
                    columns={columns}
                    dataSource={transactions}
                    scroll={handleScrollSize()}
                    locale={locale}
                    className="transaction-table"
                    onRow={(record, rowIndex) => {
                        return {
                            onClick: async (e) => {
                                const row = await onGetReceipt(record.key)
                                setTrnsctnReceipt(row)
                                return handleOpenTransactionModal()
                            }
                        }
                    }}
                    pagination={{
                        position: ['bottomRight'],
                        showSizeChanger: false,
                        pageSize: 50,
                        itemRender(page, type, element) {
                            if (type === 'prev') {
                                return (
                                    <div className="pl-4">
                                        <ArrowLeftOutlined style={{ verticalAlign: 1 }} /> Previous Page
                                    </div>
                                );
                            }
                            if (type === 'next') {
                                return (
                                    <div className="pr-4">
                                        Next Page <ArrowRightOutlined style={{ verticalAlign: 1 }} />
                                    </div>
                                );
                            }
                            return element
                        },
                    }}
                >
                </Table>
            </div>
        </div>
    )
}